import React from 'react';

const CatalogoProductosSpcPremium = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Catálogo Modelos Piso SPC Luxury</h2>
        </div>
        <div className="row mt-n1-9">
          {/* Producto 1 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/MARMOL/img0.jpg"
            altText="Piso SPC catalogo LQ8105-1"
            codigo="MÁRMOL BLANCO"
            tipo="Piso SPC Luxury"
            delay="100ms"
            estado="oferta"
          />
          {/* Producto 2 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/NOGAL/img0.jpg"
            altText="piso spc luxury catalogo 40062-8"
            codigo="NOGAL"
            tipo="Piso SPC Luxury"
            delay="200ms"
            estado="agotado"
          />
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/GRIS/img0.jpg"
            altText="piso luxury catalogo 2010-18"
            codigo="GRIS"
            tipo="Piso SPC Luxury"
            delay="300ms"
          />
          {/* Producto 4 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/MARFIL/img0.jpg"
            altText="piso spc luxury catalogo 33038-022"
            codigo="MARFIL"
            tipo="Piso SPC Luxury"
            delay="400ms"
          />
        </div>
      </div>

      {/* Estilos para los badges y el efecto grayscale */}
      <style>{`
        .badge-estado {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 2;
          padding: 6px 14px;
          border-radius: 30px;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          color: #fff;
          box-shadow: 0 2px 6px rgba(0,0,0,0.25);
        }
        .badge-agotado {
          background-color: #6c757d;
        }
        .badge-oferta {
          background-color: #dc3545;
        }
        .card-agotado {
          position: relative;
        }
      `}</style>
    </section>
  );
};

// Componente para cada producto
const Producto = ({ imgSrc, altText, codigo, tipo, delay, estado }) => {
  const imgContainerStyle = {
    height: '400px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f9fa'
  };

  const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  };

  const isAgotado = estado === 'agotado';
  const isOferta = estado === 'oferta';

  return (
    <div className={`col-sm-6 col-lg-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className={`card card-style3 border-0 text-center h-100 ${isAgotado ? 'card-agotado' : ''}`}>
        <div className="card-img position-relative" style={imgContainerStyle}>
          {isAgotado && <span className="badge-estado badge-agotado">Agotado</span>}
          {isOferta && <span className="badge-estado badge-oferta">Oferta</span>}
          <img
            src={imgSrc}
            className="card-img-top"
            alt={altText}
            style={imgStyle}
          />
        </div>
        <div className="card-body p-1-9">
          <h3 className="h5">{codigo}</h3>
          <p className="text-primary mb-0">{tipo}</p>
        </div>
      </div>
    </div>
  );
};

export default CatalogoProductosSpcPremium;